export default function () {
    $('[data-toggle="tooltip"]').tooltip();

    $('.js-form').each(function() {
        const $form = $(this);

        function removeTooltip ($el) {
            $el.closest('[data-toggle="tooltip"]').tooltip('hide');
        }

        $($form.find('select')).on('change', function() {
            removeTooltip($(this));
        });

        $form.find('.js-datepicker-container').on('change', function() {
            removeTooltip($(this).find('input'));
        });
    });
}
